<script setup lang="ts">
import AppHeader from '@/components/core/layout/AppHeader.vue';
import { useSessionStore } from '@/stores/session';
import { supabase } from '@/supabase';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { ModalsContainer } from 'vue-final-modal';
import { RouterView, useRoute } from 'vue-router';

const sessionStore = useSessionStore();

onMounted(async () => {
  const subscriptionResponse = supabase.auth.onAuthStateChange((event, session) => {
    sessionStore.setSession(session);
  });

  onUnmounted(() => {
    subscriptionResponse.data.subscription.unsubscribe();
  });
});

watch(
  () => sessionStore.shouldBypassPin,
  (shouldBypassPin) => {
    document.removeEventListener('visibilitychange', sessionStore.openPinModal);
    window.removeEventListener('blur', sessionStore.openPinModal);

    if (!shouldBypassPin) {
      document.addEventListener('visibilitychange', sessionStore.openPinModal);
      window.addEventListener('blur', sessionStore.openPinModal);
    }
  },
);

const route = useRoute();
type Animations = 'slide-fade-left' | 'slide-fade-right';
const routeAnimation = ref<Animations>('slide-fade-left');

watch(
  () => route.path,
  (newPath, oldPath) => {
    const newPathDepth = newPath.split('/').length;
    const oldPathDepth = oldPath.split('/').length;

    routeAnimation.value = newPathDepth < oldPathDepth ? 'slide-fade-right' : 'slide-fade-left';
  },
);
</script>

<template>
  <AppHeader v-if="sessionStore.session" />
  <RouterView id="routerView" v-slot="{ Component }" class="flex flex-grow flex-col overflow-auto">
    <Transition :name="routeAnimation" mode="out-in">
      <component :is="Component" />
    </Transition>
  </RouterView>
  <ModalsContainer />
</template>
